import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialDocumentsViewService {
  private showFinancialDocumentsSource = new BehaviorSubject<boolean>(false);
  showFinancialDocuments$: Observable<boolean> = this.showFinancialDocumentsSource.asObservable();

  constructor() { }

  toggleFinancialDocuments(): void {
    this.showFinancialDocumentsSource.next(!this.showFinancialDocumentsSource.value);
  }

  showFinancialDocuments(): void {
    this.showFinancialDocumentsSource.next(true);
  }

  hideFinancialDocuments(): void {
    this.showFinancialDocumentsSource.next(false);
  }
}
